<template>
  <div>

    <div class="container " id="container-1">
      <div class="row bar">
        <div class="col-12 col-md-5">
          <div class="d-flex justify-content-between mb-1">
            <div class="col-auto bg-n-red">聯絡我們</div>
            <div class="col bg-n-gray text-left">CONTACT US</div>

          </div>
        </div>
       
      </div>

     
       
        <div class="row msg-mt">
          
           
          
          <div class="col-xl-5 col-12">
             <h4 class="text-left top-text-lg">久億光電科技有限公司</h4>
            <p class="text-left top-text-sm" >LED電視牆/LED字幕機/亮化工程/招牌之服務 歡迎來電詢問</p>
            <div class="row  msg-mb text-left" style="padding-left: 15px;padding-right: 15px;">
        <div class=" col-12 msg-text px-xl-1 px-3"><img src="/static/icon/icon-03@4x.png" alt="" width="25" height="25"><p class="d-inline-block ml-2 mr-1"><a href="tel:0423899999" class="a-no-color">台中總公司 04-23899999</a></p></div>
        <div class=" col-12 msg-text px-xl-1 px-3"><img src="/static/icon/icon-04@4x.png" alt="" width="25" height="25"><p class="d-inline-block ml-2 mr-1">04-23802499</p></div>
        <div class=" col-12 msg-text px-xl-1 px-3"><img src="/static/icon/icon-05@4x.png" alt="" width="25" height="25"><p class="d-inline-block ml-2 mr-1"><a href="mailto:kuan0124@gmail.com" class="a-no-color">kuan0124@gmail.com</a></p></div>
        <div class=" col-12 msg-text px-xl-1 px-3"><img src="/static/icon/icon-06@4x.png" alt="" width="25" height="25"><p class="d-inline-block ml-2 mr-1">
          <a href="https://goo.gl/maps/uhFf6dzgxHP2" class="a-no-color">
           台中市南屯區永春路42-80號
          </a>
          <a href="https://goo.gl/maps/uhFf6dzgxHP2" class=" ml-2 d-none d-xl-inline-block" style="font-size:18px">(如何前往)</a>
          </p>
          </div>
      </div>
          </div>
          <div class="col-xl-7 col-12 google-map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3640.920734492278!2d120.61322331514658!3d24.139421684399046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34693dccebd6e565%3A0x2662688e571698b7!2z5LmF5YSE5YWJ6Zu756eR5oqA5pyJ6ZmQ5YWs5Y-4!5e0!3m2!1szh-TW!2stw!4v1551075391529" width="100%" height="416" frameborder="0" style="border:0" class="gmap d-none d-xl-block" allowfullscreen></iframe>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3640.920734492278!2d120.61322331514658!3d24.139421684399046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34693dccebd6e565%3A0x2662688e571698b7!2z5LmF5YSE5YWJ6Zu756eR5oqA5pyJ6ZmQ5YWs5Y-4!5e0!3m2!1szh-TW!2stw!4v1551075391529" width="100%" height="416" frameborder="0" style="border:0" class="gmap d-xl-none d-block" allowfullscreen></iframe>
            

          </div>
        </div>
      
      <!-- map -->
      
      
      <!-- map end --> 

      <b-form @submit="onSubmit" @reset="onReset">
        <h2  class="b-form-h2 text-left">請確實填寫以下欄位 <br class="d-block d-xl-none">我們將盡快與您聯繫並回復您的問題</h2>
       
       <hr>
         <p class="text-left need-text" style="color:rgb(171, 41, 43)"><small>*為必填</small></p>
        <div class="container" id="container-2">
          <div class="row ">
          <div class="col-xl-6 col-12 form-item">
            <div class="row ">
              <!-- red -->
              <div class="col-auto red-box">
                <div class="row h-100 align-items-center">
                  <div class="col red-box-text">公司名稱</div>
                </div>
              </div>
              <!-- gray -->
               <b-form-input type="text" v-model="form.company" placeholder="公司名稱" class="col gray-box ">
            </b-form-input>
            </div>
          </div>
          <div class="col-xl-6 col-12 form-item">
            <div class="row">
              <div class="col-auto red-box">
                <div class="row h-100 align-items-center">
                  <div class="col red-box-text">聯絡人*</div>
                </div>
              </div>
             
               <b-form-input type="text" v-model="form.user_name" placeholder="聯絡人名稱" class="col gray-box ">
            </b-form-input>

            </div>
            
          </div>
          <div class="col-xl-6 col-12 form-item">
            <div class="row">
               <div class="col-auto red-box">
                <div class="row h-100 align-items-center">
                  <div class="col red-box-text">EMAIL*</div>
                </div>
              </div>
              
               <b-form-input type="text" v-model="form.email" placeholder="輸入您的聯絡email" class="col gray-box ">
            </b-form-input>

            </div>
            
          </div>
          <div class="col-xl-6 col-12 form-item">
            <div class="row">
              <div class="col-auto red-box">
                <div class="row h-100 align-items-center">
                  <div class="col red-box-text">電話*</div>
                </div>
              </div>
              
               <b-form-input type="text" v-model="form.phone" placeholder="輸入您的聯絡電話" class="col gray-box ">
            </b-form-input>

            </div>
            
          </div>
          <div class="col-xl-6 col-12 form-item">
            <div class="row">
              <div class="col-auto red-box">
                <div class="row h-100 align-items-center">
                  <div class="col red-box-text">傳真號碼</div>
                </div>
              </div>
             
               <b-form-input type="text" v-model="form.fax" placeholder="傳真號碼" class="col gray-box ">
            </b-form-input>

            </div>
            
          </div>
          <div class="col-xl-6 col-12 form-item">
            <div class="row">
              <div class="col-auto red-box">
                <div class="row h-100 align-items-center">
                  <div class="col red-box-text">地址*</div>  
                </div>
              </div>
              
               <b-form-input type="text" v-model="form.address" placeholder="輸入您的聯絡地址" class="col gray-box ">
            </b-form-input>

            </div>
            
          </div>
          <!-- full -->
             <div class="col-12 form-item-full">
            <div class="row">
              <div class="col-auto red-box">
                <div class="row h-100 align-items-center">
                  <div class="col red-box-text">主旨</div>
                </div>
              </div>
              
               <b-form-input type="text" v-model="form.title" placeholder="輸入主旨" class="col gray-box ">
            </b-form-input>

            </div>
            
          </div>
          <!-- full-2 -->
           <div class="col-12 form-item-full">
            <div class="row">
              <div class="col-auto red-box" >
                <p  class=" red-box-text">備註*</p>
               
                
              </div>
              <b-form-textarea v-model="form.content" placeholder="" :rows="4" :max-rows="10" class="col gray-box-textarea">
            </b-form-textarea>

            </div>
            
          </div>
          
        </div>
        </div>
        <!-- form content -->
        <div class="container text-center" id="container-3">
           
          <b-button type="reset" variant="danger"  class=" btn-left ">重設</b-button>
          <b-button type="submit" variant="dark"  class=" btn-right">{{ submit ? '處理中' : '送出'}}</b-button>

        
        </div>
       
      </b-form>
    </div>

  </div>
</template>





<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

export default {
  data(){
    return{
      submit: false,
      form: {
        user_name: '',
        email: '',
        phone: '',
        title: '',
        content: '',
        company: '',
        fax: '',
        address: ''
      },
      a: [
        {
          xs: "/static/contact/320/1.jpg",
          sm: "/static/contact/320/1.jpg",
          md: "/static/contact/768/1.jpg",
          lg: "/static/contact/768/1.jpg",
          xl: "/static/contact/1200/1.jpg"
        }
      ]
    }
  },
  methods: {
    getData() {
      let vm = this;

      
    }
    ,
    pusha() {
      let vm = this;
      vm.$emit("pusha", vm.a);
    },
    onSubmit (evt) {
      evt.preventDefault();
      let vm = this;
      if (vm.submit) {
        return;
      }
      
      // console.log(vm.form)
      this.submit = true;
      axios({
        method: "post",
        url: "https://iled.com.tw/bridging/api/v1/contact",
        params: vm.form
      })
        .then(function(response) {

        
          if(response.data.status==true){
            
            // alert();
            Vue.$toast.open({
              message: response.data.message,
              type: 'success'
            });
            vm.onReset(evt)
            
          }
          else{
        
            Vue.$toast.open({
              message: response.data.error[0]['message'],
              type: 'error'
            });
            // alert(response.data.error[0]['message']);
            //等等
            
          }
          console.log(response)
          
        }).finally(() => {
          this.submit = false;
    
        });
      
    },
    onReset (evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.user_name = '';
      this.form.email = '';
      this.form.phone = '';
      this.form.title = '';
      this.form.content = '';
      this.form.company = '';
      this.form.fax = '';
      this.form.address = '';
      // alert('reseted')
    }
  },
  created: function() {
    this.pusha()
  },
  mounted: function() {

  }
}
</script>

<style lang="sass" scoped>
@import "~bootstrap/scss/bootstrap"

h1
  color: black
  font-weight: bold
  font-size: 43px
  text-align: left


.left-word
  color: black
  width: 150px
  font-size: 18px
  text-align: left

.bg-n-red
  @include media-breakpoint-up(xs)
    font-size: 14px
  @include media-breakpoint-up(xl)
    font-size: 25px
  background-color: rgb(182, 40 ,44)
  color: white
  text-align: center
  padding-top: 7px
  padding-bottom: 7px
.bg-n-gray
  @include media-breakpoint-up(xs)
    font-size: 14px
  @include media-breakpoint-up(xl)
    font-size: 25px
  background-color: rgb(51, 58, 64)
  color: white
  padding-left: 13px
  padding-top: 7px
  padding-bottom: 7px 
.gmap
  @include media-breakpoint-up(xl)
    margin-bottom: 100px
  @include media-breakpoint-up(xs)
    margin-bottom: 77px
.form-item:nth-child(odd)
  @include media-breakpoint-up(xl)
    padding-right: 42px
    margin-bottom: 44px
  @include media-breakpoint-up(xs)
    margin-bottom: 22px
.form-item:nth-child(even)
  @include media-breakpoint-up(xl)
    padding-left: 42px
    margin-bottom: 44px
  @include media-breakpoint-up(xs)
    margin-bottom: 22px
.form-item-full:nth-child(odd)
  @include media-breakpoint-up(xl)
    margin-bottom: 44px
  @include media-breakpoint-up(xs)
    margin-bottom: 22px
.text-left
  h4
    colr: red
hr
  @include media-breakpoint-up(xl)
    margin-top: 20px
    margin-bottom: 10px
  @include media-breakpoint-up(xs)
    margin-top: 10px
    margin-bottom: 0px
.gray-box
  background-color: rgb(219, 220, 220)
  @include media-breakpoint-up(xs)
    padding-top: 3px
    padding-bottom: 3px
    line-height: 8.5px
  @include media-breakpoint-up(xl)
    padding-top: 7.5px
    padding-bottom: 7.5px
    line-height: 1.5
.gray-box-textarea
  background-color: rgb(219, 220, 220)
.red-box
  background-color: rgb(171, 41, 43)
  margin-right: 10px
  border: 2px solid rgb(171, 41, 43)
  border-radius: 10px
  @include media-breakpoint-up(xl)
    margin-right: 42px
    width: 120px
    height: 47px
  @include media-breakpoint-up(xs)
    width: 95px
    height: 39px
.red-box-text
  color: white
  @include media-breakpoint-up(xl)
    font-size: 21px
    line-height: 47px
  @include media-breakpoint-up(xs)
    font-size: 14.3px
    line-height: 35px
.msg-mb
  @include media-breakpoint-up(xl)
    margin-bottom: 0
    margin-top: 0
  @include media-breakpoint-up(xs)
    margin-bottom: 50px
    margin-top: 50px
.msg-mt
  @include media-breakpoint-up(xl)
    margin-top: 20px
  @include media-breakpoint-up(xs)
    margin-top: 0
.msg-text
  @include media-breakpoint-up(xs)
      font-size: 18px
  @include media-breakpoint-up(xl)
    font-size: 21px
  color: rgb(52, 58, 64)
  font-weight: bold
.msg-text:nth-child(1)
  color: rgb(171, 41, 43)
.bar
  @include media-breakpoint-up(xl)
    margin-bottom: 50px
  @include media-breakpoint-up(xl)
    margin-bottom: 16px
.top-text-lg
  @include media-breakpoint-up(xl)
    margin-top: 15px
    font-size: 40px
    font-weight: bold
  @include media-breakpoint-up(xs)
    margin-top: 15px
    margin-bottom: 20px
    font-size: 28.5px
    font-weight: bold
    letter-spacing: 4px
.google-map
  @include media-breakpoint-up(xl)
    margin-top: 15px
.top-text-sm
  @include media-breakpoint-up(xl)
    font-size: 19px
    font-weight: bold
  @include media-breakpoint-up(xs)
    font-size: 14px
    font-weight: bold
    letter-spacing: 2px
#container-1
  @include media-breakpoint-up(xl)
    padding-top: 118px
    padding-bottom:  212px
  @include media-breakpoint-up(xs)
    padding-top: 46px
    padding-bottom:  146px
#container-2
  margin-bottom: 40px
.b-form-h2
  @include media-breakpoint-up(xl)
    font-size: 24px
    font-weight: bold
  @include media-breakpoint-up(xs)
    font-size: 14px
    font-weight: bold
    line-height: 21px

.btn-left
  @include media-breakpoint-up(xl)
    width: 207px
    margin-right: 80px
    margin-top: 30px
    font-size: 22px
  @include media-breakpoint-up(xs)
    width: 100px
    margin-right: 50px
    margin-top: 0
    font-size: 12.64px
    font-weight: bold
.btn-right
  @include media-breakpoint-up(xl)
    width: 207px
    margin-top: 30px
    font-size: 22px
  @include media-breakpoint-up(xs)
    width: 100px
    font-size: 12.64px
    margin-top: 0
    font-weight: bold
.btn-danger
  background-color: rgb(171, 41, 43)
  border-color: rgb(171, 41, 43)
.need-text
  margin-bottom: 40px
.a-no-color
  color: black !important
</style>




// WEBPACK FOOTER //
// src/components/Contact.vue